<template>
  <div class="hs-switch">
    <input maxlength='50' class="hs-switch-input" type="checkbox" v-model="currentValue" :disabled="disabled">
    <i class="hs-switch-ui"></i>
    <span class="hs-switch-label"><slot></slot></span>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        return this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @require "../../common/stylus/variable.styl"
  $switch-width = 48px
  $switch-height = 28px
  .hs-switch
    display: flex
    position: relative
    align-items: center
    .hs-switch-input
      position: absolute
      z-index: 1
      width: $switch-width
      height: $switch-height
      opacity: 0
      &:checked + .hs-switch-ui
        border-color: $color_theme
        background-color: $color_theme
        &::before
          transform: scale(0)
        &::after
          transform: translateX($switch-width - $switch-height)
      &:disabled + .hs-switch-ui
        opacity: 0.3
    .hs-switch-ui
      position: relative
      display: block
      width: $switch-width
      height: $switch-height
      box-sizing: content-box
      border: 1px solid $color_gray_layer
      border-radius: $switch-height
      background-color: $color_gray_layer
      &::before, &::after
        content: ""
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        border-radius: $switch-height
        background-color: $switch-off-bgc
        transition: transform .4s cubic-bezier(.25, .1, .25, 1.28)
      &::after
        width: $switch-height
        background-color: $color_white
        box-shadow: 0 1px 3px rgba(0, 0, 0, .4)
    .hs-switch-label
      display: block
      margin-left: 10px
      &:empty
        margin-left: 0
</style>
